/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BooleanApiResult,
    BooleanApiResultFromJSON,
    LLMUsage,
    LLMUsageApiResult,
    LLMUsageApiResultFromJSON,
    LLMUsageIReadOnlyCollectionApiResult,
    LLMUsageIReadOnlyCollectionApiResultFromJSON,
    LLMUsageInsertDto,
    LLMUsageInsertDtoToJSON,
    LLMUsagePageOfApiResult,
    LLMUsagePageOfApiResultFromJSON,
    LLMUsageUpdateDto,
    LLMUsageUpdateDtoToJSON,
    TotalUsageApiResult,
    TotalUsageApiResultFromJSON,
} from '../models';

export interface LLMUsageDeleteByIdRequest {
    id: string;
}

export interface LLMUsageGetByIdRequest {
    id: string;
}

export interface LLMUsageGetForProjectRequest {
    projectId: string;
    page?: number;
    perPage?: number;
    startDate?: Date;
    endDate?: Date;
}

export interface LLMUsageGetPageRequest {
    page?: number;
    perPage?: number;
    startDate?: Date;
    endDate?: Date;
}

export interface LLMUsageGetTotalUsageForProjectRequest {
    projectId: string;
    startDate?: Date;
    endDate?: Date;
}

export interface LLMUsageInsertRequest {
    llmUsageInsertDto?: LLMUsageInsertDto;
}

export interface LLMUsageUpdateRequest {
    llmUsageUpdateDto?: LLMUsageUpdateDto;
}

/**
 * LLMUsageApi - interface
 *
 * @export
 * @interface LLMUsageApiInterface
 */
export interface LLMUsageApiInterface {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMUsageApiInterface
     */
    llmUsageDeleteByIdRaw(requestParameters: LLMUsageDeleteByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BooleanApiResult>>;

    /**
     */
    llmUsageDeleteById(id: string, initOverrides?: RequestInit): Promise<BooleanApiResult>;

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMUsageApiInterface
     */
    llmUsageGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsageIReadOnlyCollectionApiResult>>;

    /**
     */
    llmUsageGet(initOverrides?: RequestInit): Promise<LLMUsageIReadOnlyCollectionApiResult>;

    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMUsageApiInterface
     */
    llmUsageGetByIdRaw(requestParameters: LLMUsageGetByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsageApiResult>>;

    /**
     */
    llmUsageGetById(id: string, initOverrides?: RequestInit): Promise<LLMUsageApiResult>;

    /**
     *
     * @param {string} projectId
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {Date} [startDate]
     * @param {Date} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMUsageApiInterface
     */
    llmUsageGetForProjectRaw(requestParameters: LLMUsageGetForProjectRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsagePageOfApiResult>>;

    /**
     */
    llmUsageGetForProject(projectId: string, page?: number, perPage?: number, startDate?: Date, endDate?: Date, initOverrides?: RequestInit): Promise<LLMUsagePageOfApiResult>;

    /**
     *
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {Date} [startDate]
     * @param {Date} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMUsageApiInterface
     */
    llmUsageGetPageRaw(requestParameters: LLMUsageGetPageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsagePageOfApiResult>>;

    /**
     */
    llmUsageGetPage(page?: number, perPage?: number, startDate?: Date, endDate?: Date, initOverrides?: RequestInit): Promise<LLMUsagePageOfApiResult>;

    /**
     *
     * @param {string} projectId
     * @param {Date} [startDate]
     * @param {Date} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMUsageApiInterface
     */
    llmUsageGetTotalUsageForProjectRaw(requestParameters: LLMUsageGetTotalUsageForProjectRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<TotalUsageApiResult>>;

    /**
     */
    llmUsageGetTotalUsageForProject(projectId: string, startDate?: Date, endDate?: Date, initOverrides?: RequestInit): Promise<TotalUsageApiResult>;

    /**
     *
     * @param {LLMUsageInsertDto} [llmUsageInsertDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMUsageApiInterface
     */
    llmUsageInsertRaw(requestParameters: LLMUsageInsertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsageApiResult>>;

    /**
     */
    llmUsageInsert(llmUsageInsertDto?: LLMUsageInsertDto, initOverrides?: RequestInit): Promise<LLMUsageApiResult>;

    /**
     *
     * @param {LLMUsageUpdateDto} [llmUsageUpdateDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMUsageApiInterface
     */
    llmUsageUpdateRaw(requestParameters: LLMUsageUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsageApiResult>>;

    /**
     */
    llmUsageUpdate(llmUsageUpdateDto?: LLMUsageUpdateDto, initOverrides?: RequestInit): Promise<LLMUsageApiResult>;

}

/**
 * LLMUsageApi - object-oriented interface
 *
 * @export
 * @class LLMUsageApi
 * @extends {runtime.BaseAPI}
 */
export class LLMUsageApi extends runtime.BaseAPI implements LLMUsageApiInterface {

    /**
     */
    async llmUsageDeleteByIdRaw(requestParameters: LLMUsageDeleteByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BooleanApiResult>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling llmUsageDeleteById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/LLMUsage/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BooleanApiResultFromJSON(jsonValue));
    }

    /**
     */
    async llmUsageDeleteById(id: string, initOverrides?: RequestInit): Promise<BooleanApiResult> {
        const response = await this.llmUsageDeleteByIdRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async llmUsageGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsageIReadOnlyCollectionApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/LLMUsage/Get`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LLMUsageIReadOnlyCollectionApiResultFromJSON(jsonValue));
    }

    /**
     */
    async llmUsageGet(initOverrides?: RequestInit): Promise<LLMUsageIReadOnlyCollectionApiResult> {
        const response = await this.llmUsageGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async llmUsageGetByIdRaw(requestParameters: LLMUsageGetByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsageApiResult>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling llmUsageGetById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/LLMUsage/Get/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LLMUsageApiResultFromJSON(jsonValue));
    }

    /**
     */
    async llmUsageGetById(id: string, initOverrides?: RequestInit): Promise<LLMUsageApiResult> {
        const response = await this.llmUsageGetByIdRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async llmUsageGetForProjectRaw(requestParameters: LLMUsageGetForProjectRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsagePageOfApiResult>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling llmUsageGetForProject.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['perPage'] = requestParameters.perPage;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = (requestParameters.endDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/LLMUsage/GetForProject/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LLMUsagePageOfApiResultFromJSON(jsonValue));
    }

    /**
     */
    async llmUsageGetForProject(projectId: string, page?: number, perPage?: number, startDate?: Date, endDate?: Date, initOverrides?: RequestInit): Promise<LLMUsagePageOfApiResult> {
        const response = await this.llmUsageGetForProjectRaw({ projectId: projectId, page: page, perPage: perPage, startDate: startDate, endDate: endDate }, initOverrides);
        return await response.value();
    }

    /**
     */
    async llmUsageGetPageRaw(requestParameters: LLMUsageGetPageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsagePageOfApiResult>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['perPage'] = requestParameters.perPage;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = (requestParameters.endDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/LLMUsage/GetPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LLMUsagePageOfApiResultFromJSON(jsonValue));
    }

    /**
     */
    async llmUsageGetPage(page?: number, perPage?: number, startDate?: Date, endDate?: Date, initOverrides?: RequestInit): Promise<LLMUsagePageOfApiResult> {
        const response = await this.llmUsageGetPageRaw({ page: page, perPage: perPage, startDate: startDate, endDate: endDate }, initOverrides);
        return await response.value();
    }

    /**
     */
    async llmUsageGetTotalUsageForProjectRaw(requestParameters: LLMUsageGetTotalUsageForProjectRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<TotalUsageApiResult>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling llmUsageGetTotalUsageForProject.');
        }

        const queryParameters: any = {};

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = (requestParameters.endDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/LLMUsage/GetTotalUsageForProject/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TotalUsageApiResultFromJSON(jsonValue));
    }

    /**
     */
    async llmUsageGetTotalUsageForProject(projectId: string, startDate?: Date, endDate?: Date, initOverrides?: RequestInit): Promise<TotalUsageApiResult> {
        const response = await this.llmUsageGetTotalUsageForProjectRaw({ projectId: projectId, startDate: startDate, endDate: endDate }, initOverrides);
        return await response.value();
    }

    /**
     */
    async llmUsageInsertRaw(requestParameters: LLMUsageInsertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsageApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/LLMUsage/Insert`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LLMUsageInsertDtoToJSON(requestParameters.llmUsageInsertDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LLMUsageApiResultFromJSON(jsonValue));
    }

    /**
     */
    async llmUsageInsert(llmUsageInsertDto?: LLMUsageInsertDto, initOverrides?: RequestInit): Promise<LLMUsageApiResult> {
        const response = await this.llmUsageInsertRaw({ llmUsageInsertDto: llmUsageInsertDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async llmUsageUpdateRaw(requestParameters: LLMUsageUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LLMUsageApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/LLMUsage/Update`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LLMUsageUpdateDtoToJSON(requestParameters.llmUsageUpdateDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LLMUsageApiResultFromJSON(jsonValue));
    }

    /**
     */
    async llmUsageUpdate(llmUsageUpdateDto?: LLMUsageUpdateDto, initOverrides?: RequestInit): Promise<LLMUsageApiResult> {
        const response = await this.llmUsageUpdateRaw({ llmUsageUpdateDto: llmUsageUpdateDto }, initOverrides);
        return await response.value();
    }

} 